import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

import { ArtificialIntelligenceApi } from 'Api/ArtificialIntelligence/ArtificialIntelligenceApi';
import { ControlsApi } from 'Api/Controls/ControlsApi';
import { Alert } from 'Components/Alert/Alert';
import { Button } from 'Components/Buttons/Buttons';
import { Modal } from 'Components/Modal/Modal';
import { SaveControlFormFields, SaveControlFromFieldsProps, useSaveControl } from 'Components/OperationalControls/SaveControl/SaveControl';
import { ICON_CLOSE } from 'Config/Icons';

export interface CreateControlModalProps {
    artificialIntelligenceApi: ArtificialIntelligenceApi;
    hideModal: () => void;
    onControlCreated: () => void;
    controlsApi: ControlsApi;
    controlFramework: string;
    controlGroupId: string;
}

export const CreateControlModal = (props: CreateControlModalProps) => {
    const [successMessage, setSuccessMessage] = useState<string>();
    const [failureMessage, setFailureMessage] = useState<string>();
    const { saveControlStatus, saveControlFormFieldsValues, error, saveControl, handleChange, handleSelectChange } = useSaveControl(props.controlFramework, props.controlGroupId, props.controlsApi, {
        controlName: '',
        controlText: [],
    });

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        await saveControl();
    };

    const { onControlCreated } = props;

    useEffect(() => {
        switch (saveControlStatus) {
            case 'saved':
                setSuccessMessage('Control created.');
                onControlCreated();
                break;
            case 'error':
                setFailureMessage(error?.message);
                break;
            default:
                setSuccessMessage(undefined);
                setFailureMessage(undefined);
        }
    }, [error, onControlCreated, saveControlStatus]);

    const saveControlFormFieldsProps: SaveControlFromFieldsProps = {
        artificialIntelligenceApi: props.artificialIntelligenceApi,
        saveControlFormFieldsValues: saveControlFormFieldsValues,
        handleChange: handleChange,
        handleSelectChange: handleSelectChange,
        disabled: saveControlStatus === 'saved',
    };

    return (
        <Modal open header="Create Custom Control">
            {successMessage && <Alert type="success">{successMessage}</Alert>}
            {failureMessage && error && <Alert type="error">{failureMessage}</Alert>}
            <Box component="form" noValidate onSubmit={handleSubmit}>
                <SaveControlFormFields {...saveControlFormFieldsProps} />
                <div className={'modalFormButtonContainer'}>
                    <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                        Close
                    </Button>
                    <Button variant="submit" disabled={saveControlStatus === 'saved'} isLoading={saveControlStatus === 'saving'} loadingText="Creating...">
                        CREATE
                    </Button>
                </div>
            </Box>
        </Modal>
    );
};
